import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { myAccountApi } from "@/features/my-account/api";
import { SearchedSku } from "@/features/my-account/types";

const useGetSearchedSkus = (keyword: string, buyer_id: number) => {
  const { data: searchedSkus } = useSuspenseQuery<SearchedSku>({
    queryKey: ["my-account", "searched-skus", buyer_id, keyword],
    queryFn: () =>
      myAccountApi.getSearchedSkus(buyer_id, {
        keyword,
      }),
    refetchOnMount: "always",
  });

  return {
    searchedSkus: searchedSkus.skus,
  };
};

export default useGetSearchedSkus;
